import type { LinkProps } from '@trg/tlw-ui-component';
import type { ProductCardBasicProps } from './product-card.type';
import { ProductCardContextProvider } from './ProductCardContext';
import { ProductCardForDefault } from './ProductCardForDefault';
import { ProductCardForSimple } from './ProductCardForSimple';

export type ProductCardProps = LinkProps & ProductCardBasicProps;

export function ProductCard({
  catalog,
  product,
  mode = 'vertical',
  showFavorite = true,
  squarePreview = true,
  small,
  simple,
  ...props
}: ProductCardProps) {
  return (
    <ProductCardContextProvider
      {...{
        catalog,
        product,
        mode,
        showFavorite,
        squarePreview,
        small,
        simple,
      }}
    >
      {simple ? (
        <ProductCardForSimple {...props} />
      ) : (
        <ProductCardForDefault {...props} />
      )}
    </ProductCardContextProvider>
  );
}
